import moment from 'moment';
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { ACTIVE_SESSIONS } from '../constant/actionTypes';

export const getActiveSessionData = (obj) => (dispatch) => {
  dispatch({
    payload: [],
    type: ACTIVE_SESSIONS.GET.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.GET_ALL_ACTIVE_SESSON_DATA}?page=${obj.page}&size=${obj.size}`)
    .then((activeSessionsData) => {
      const rows = activeSessionsData.data.response.data.sessions;
      const count = activeSessionsData.data.response.data.totalItems;
      const responseData = rows.map((data) => (
        { ...data, lastActive: moment(parseInt(data.lastActive)).format('DD/MM/YYYY hh:mm A') }
      ));
      dispatch({
        payload: { data: responseData, count },
        type: ACTIVE_SESSIONS.GET.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: ACTIVE_SESSIONS.GET.ERROR,
      });
    });
};

export const logoutAllUserSessions = () => httpservice()
  .delete(`${constants.API.GET_ALL_ACTIVE_SESSON_DATA}`)
  .then((allLogoutSessions) => ({ data: allLogoutSessions.data, status: 1 }))
  .catch((error) => ({ data: error.response && error.response.data ? error.response.data : error, status: 0 }));

export const logoutSingleUserDevice = (sessionUUID) => httpservice()
  .get(`${constants.API.SINGLE_ACTIVE_SESSION}?sessionUUID=${sessionUUID}`)
  .then((singleLogoutSession) => ({ data: singleLogoutSession.data, status: 1 }))
  .catch((error) => ({ data: error.response && error.response.data ? error.response.data : error, status: 0 }));
